'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002422 from "./presto.-Dashboard-View$$anon$22.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024 from "./presto.types$-Account-Name$.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dAccount$002dStats$0024 from "./presto.types$-Dashboard-Account-Stats$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$21() {
  this.aKo = null;
  this.aKg = null;
  this.aKh = false;
  this.aKp = null;
  this.aKq = false;
  this.aKt = null;
  this.aKm = null;
  this.aKn = false;
  this.aKi = null;
  this.aKj = false;
  this.aKk = null;
  this.aKl = false;
  this.aKr = false;
  this.aKs = false;
  this.aKo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aKt = "DashboardAccountStats";
}
export { $c_Lpresto_DashboardView$$anon$21 as $c_Lpresto_DashboardView$$anon$21 };
$p = $c_Lpresto_DashboardView$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$21;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$21() {
}
export { $h_Lpresto_DashboardView$$anon$21 as $h_Lpresto_DashboardView$$anon$21 };
$h_Lpresto_DashboardView$$anon$21.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aKo;
});
$p.L = (function() {
  if ((!this.aKh)) {
    this.aKg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aKh = true;
  }
  return this.aKg;
});
$p.O = (function() {
  if ((!this.aKq)) {
    this.aKp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aKq = true;
  }
  return this.aKp;
});
$p.E = (function() {
  return this.aKt;
});
$p.t = (function() {
  if ((!this.aKn)) {
    this.aKm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKn = true;
  }
  return this.aKm;
});
$p.M = (function() {
  if ((!this.aKj)) {
    this.aKi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dName$0024.$m_Lpresto_types$AccountName$().adp(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aKj = true;
  }
  return this.aKi;
});
$p.Q = (function() {
  if ((!this.aKl)) {
    this.aKk = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002422.$c_Lpresto_DashboardView$$anon$22();
    this.aKl = true;
  }
  return this.aKk;
});
$p.w = (function() {
  if ((!this.aKs)) {
    this.aKr = false;
    this.aKs = true;
  }
  return this.aKr;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee111) => ((p) => \u03b4scrutinee111.cGk(p)))($j_presto$002etypes$0024$002dDashboard$002dAccount$002dStats$0024.$m_Lpresto_types$DashboardAccountStats$())));
});
var $d_Lpresto_DashboardView$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$21, "presto.DashboardView$$anon$21", ({
  GM: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$21 as $d_Lpresto_DashboardView$$anon$21 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$21.js.map
